import { render, staticRenderFns } from "./PxAutocompleteConfiguracaoFrete.vue?vue&type=template&id=33c6a77f"
import script from "./PxAutocompleteConfiguracaoFrete.vue?vue&type=script&lang=js"
export * from "./PxAutocompleteConfiguracaoFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports